module.exports = __webpack_public_path__ + "img/login-mobile.a17e39dc.jpg";